!function (t, s) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = s() : "function" == typeof define && define.amd ? define(s) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_duration = s();
}(this, function () {
  "use strict";

  var t,
    s,
    n = 1e3,
    i = 6e4,
    e = 36e5,
    r = 864e5,
    o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    u = 31536e6,
    d = 2628e6,
    a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,
    h = {
      years: u,
      months: d,
      days: r,
      hours: e,
      minutes: i,
      seconds: n,
      milliseconds: 1,
      weeks: 6048e5
    },
    c = function c(t) {
      return t instanceof g;
    },
    f = function f(t, s, n) {
      return new g(t, n, s.$l);
    },
    m = function m(t) {
      return s.p(t) + "s";
    },
    l = function l(t) {
      return t < 0;
    },
    $ = function $(t) {
      return l(t) ? Math.ceil(t) : Math.floor(t);
    },
    y = function y(t) {
      return Math.abs(t);
    },
    v = function v(t, s) {
      return t ? l(t) ? {
        negative: !0,
        format: "" + y(t) + s
      } : {
        negative: !1,
        format: "" + t + s
      } : {
        negative: !1,
        format: ""
      };
    },
    g = function () {
      function l(t, s, n) {
        var i = this;
        if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
        if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
        if ("object" == typeof t) return Object.keys(t).forEach(function (s) {
          i.$d[m(s)] = t[s];
        }), this.calMilliseconds(), this;
        if ("string" == typeof t) {
          var e = t.match(a);
          if (e) {
            var r = e.slice(2).map(function (t) {
              return null != t ? Number(t) : 0;
            });
            return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var y = l.prototype;
      return y.calMilliseconds = function () {
        var t = this;
        this.$ms = Object.keys(this.$d).reduce(function (s, n) {
          return s + (t.$d[n] || 0) * h[n];
        }, 0);
      }, y.parseFromMilliseconds = function () {
        var t = this.$ms;
        this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
      }, y.toISOString = function () {
        var t = v(this.$d.years, "Y"),
          s = v(this.$d.months, "M"),
          n = +this.$d.days || 0;
        this.$d.weeks && (n += 7 * this.$d.weeks);
        var i = v(n, "D"),
          e = v(this.$d.hours, "H"),
          r = v(this.$d.minutes, "M"),
          o = this.$d.seconds || 0;
        this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
        var u = v(o, "S"),
          d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative,
          a = e.format || r.format || u.format ? "T" : "",
          h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
        return "P" === h || "-P" === h ? "P0D" : h;
      }, y.toJSON = function () {
        return this.toISOString();
      }, y.format = function (t) {
        var n = t || "YYYY-MM-DDTHH:mm:ss",
          i = {
            Y: this.$d.years,
            YY: s.s(this.$d.years, 2, "0"),
            YYYY: s.s(this.$d.years, 4, "0"),
            M: this.$d.months,
            MM: s.s(this.$d.months, 2, "0"),
            D: this.$d.days,
            DD: s.s(this.$d.days, 2, "0"),
            H: this.$d.hours,
            HH: s.s(this.$d.hours, 2, "0"),
            m: this.$d.minutes,
            mm: s.s(this.$d.minutes, 2, "0"),
            s: this.$d.seconds,
            ss: s.s(this.$d.seconds, 2, "0"),
            SSS: s.s(this.$d.milliseconds, 3, "0")
          };
        return n.replace(o, function (t, s) {
          return s || String(i[t]);
        });
      }, y.as = function (t) {
        return this.$ms / h[m(t)];
      }, y.get = function (t) {
        var s = this.$ms,
          n = m(t);
        return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
      }, y.add = function (t, s, n) {
        var i;
        return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
      }, y.subtract = function (t, s) {
        return this.add(t, s, !0);
      }, y.locale = function (t) {
        var s = this.clone();
        return s.$l = t, s;
      }, y.clone = function () {
        return f(this.$ms, this);
      }, y.humanize = function (s) {
        return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
      }, y.valueOf = function () {
        return this.asMilliseconds();
      }, y.milliseconds = function () {
        return this.get("milliseconds");
      }, y.asMilliseconds = function () {
        return this.as("milliseconds");
      }, y.seconds = function () {
        return this.get("seconds");
      }, y.asSeconds = function () {
        return this.as("seconds");
      }, y.minutes = function () {
        return this.get("minutes");
      }, y.asMinutes = function () {
        return this.as("minutes");
      }, y.hours = function () {
        return this.get("hours");
      }, y.asHours = function () {
        return this.as("hours");
      }, y.days = function () {
        return this.get("days");
      }, y.asDays = function () {
        return this.as("days");
      }, y.weeks = function () {
        return this.get("weeks");
      }, y.asWeeks = function () {
        return this.as("weeks");
      }, y.months = function () {
        return this.get("months");
      }, y.asMonths = function () {
        return this.as("months");
      }, y.years = function () {
        return this.get("years");
      }, y.asYears = function () {
        return this.as("years");
      }, l;
    }(),
    p = function p(t, s, n) {
      return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
  return function (n, i, e) {
    t = e, s = e().$utils(), e.duration = function (t, s) {
      var n = e.locale();
      return f(t, {
        $l: n
      }, s);
    }, e.isDuration = c;
    var r = i.prototype.add,
      o = i.prototype.subtract;
    i.prototype.add = function (t, s) {
      return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
    }, i.prototype.subtract = function (t, s) {
      return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
    };
  };
});